// Sidebar toggle functionality
document.addEventListener('DOMContentLoaded', function() {
  const sidebarToggle = document.getElementById('sidebar-toggle')
  const sidebar = document.getElementById('sidebar')

  if (!sidebarToggle || !sidebar) {
    return
  }

  // Initialize sidebar state (open by default)
  let sidebarOpen = localStorage.getItem('sidebarOpen') !== 'false' // Default to true unless explicitly set to false

  // Apply initial state
  updateSidebarState(sidebarOpen)

  // Toggle sidebar function
  function toggleSidebar() {
    sidebarOpen = !sidebarOpen
    updateSidebarState(sidebarOpen)
    localStorage.setItem('sidebarOpen', sidebarOpen.toString())
  }

  // Toggle button click handler
  sidebarToggle.addEventListener('click', toggleSidebar)

  // Keyboard shortcut handler
  document.addEventListener('keydown', function(event) {
    // Check for Cmd+Shift+S (Mac) or Ctrl+Shift+S (Windows/Linux)
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
    const modifierKey = isMac ? event.metaKey : event.ctrlKey

    if (modifierKey && event.shiftKey && event.key.toLowerCase() === 's') {
      event.preventDefault() // Prevent browser's default save dialog
      toggleSidebar()
    }
  })

  function updateSidebarState(isOpen) {
    const fadeElements = sidebar.querySelectorAll('.fade-content')

    if (isOpen) {
      // Opening: First set width, then fade in text
      sidebar.classList.remove('sidebar-closed')
      sidebar.classList.add('sidebar-open')

      // Fade in text elements after width animation starts
      setTimeout(() => {
        fadeElements.forEach(el => {
          el.style.opacity = '1'
        })
      }, 100)
    } else {
      // Closing: First fade out text, then reduce width
      fadeElements.forEach(el => {
        el.style.opacity = '0'
      })

      // Change width after text has faded out
      setTimeout(() => {
        sidebar.classList.remove('sidebar-open')
        sidebar.classList.add('sidebar-closed')
      }, 150)
    }
  }
})